import CompareAndDownload from './CompareAndDownload';
export default CompareAndDownload;
